import React, { FC } from 'react';
import { Article as IArticle } from 't2-graphql-types';
import { formatDate } from '../../../utils/formatDate';
import Typo from '../Typography/Typo';
import { generateTimePointText } from './ArticleHeaderInfo';
import ArticleHeaderInfoDetailsElement from './ArticleHeaderInfoDetailsElement';
import { ArticleAuthorLink } from './ArticleAurthorLink';

type TArticleHeaderInfoDetailsProps = Pick<Required<IArticle>, 'readTime' | 'author' | 'publishedAt'>;

const ArticleHeaderInfoDetails: FC<TArticleHeaderInfoDetailsProps> = ({ author, readTime, publishedAt }) => {
  const detailItems = [
    {
      id: '1',
      element: <ArticleAuthorLink author={author!} />,
      shouldDisplay: true,
    },
    {
      id: '2',
      element: <Typo variant="p2" className="!text-sm md:!text-base text-gray-700" text={formatDate(publishedAt)} />,
      shouldDisplay: true,
    },
    {
      id: '3',
      element: (
        <Typo
          variant="p2"
          className="!text-sm md:!text-base text-gray-700"
          text={generateTimePointText(readTime as unknown as number)}
        />
      ),
      shouldDisplay: true,
    },
  ];

  return (
    <div className="flex h-fit flex-wrap gap-x-3 gap-y-4 justify-center items-center test">
      {detailItems
        .filter(({ shouldDisplay }) => shouldDisplay)
        .map((item, index) => {
          const isFirst = index === 0;
          const isSecond = index === 1;
          return (
            <ArticleHeaderInfoDetailsElement isFirst={isFirst} isSecond={isSecond} key={item.id}>
              {item.element}
            </ArticleHeaderInfoDetailsElement>
          );
        })}
    </div>
  );
};

export default ArticleHeaderInfoDetails;
